import React from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import { GlobalConfigState } from 'src/components/LicenseConfig/GlobalConfig/GlobalConfigState';
import { ComplianceConfigurationLicenseConfigForm } from 'src/components/ComplianceConfiguration/LicenseConfig/ComplianceConfigurationLicenseConfigForm';
import { configFieldKeys, configFieldLabels } from 'src/components/LicenseConfig/shared/configFields';

interface ComplianceConfigurationLicenseConfigDisplayPropsType {
    state: GlobalConfigState;
}

export const ComplianceConfigurationLicenseConfigDisplay = observer(
    ({ state }: ComplianceConfigurationLicenseConfigDisplayPropsType): JSX.Element => {
        const selectedCurrency = state.selectedCurrency;
        const selectedConfig = state.selectedConfig;

        if (selectedCurrency === null) {
            return (
                <Alert
                    icon='info'
                    title='Select currency'
                    variant='default'
                >
                    Please select a currency to view configuration.
                </Alert>
            );
        }

        const isNewConfig = selectedConfig === null;

        const fields = configFieldKeys.map((field) => ({
            key: field,
            label: configFieldLabels[field],
            formInputState: state[field],
            originalValue: isNewConfig ? '' : selectedConfig[field],
        }));

        return (
            <ComplianceConfigurationLicenseConfigForm
                currency={selectedCurrency}
                fields={fields}
                isSaving={state.isSaving}
                onSubmit={state.updateConfig}
                title={isNewConfig ? 'New global configuration' : 'Global configuration'}
            />
        );
    }
);
